import { render, staticRenderFns } from "./order-sort-modal.vue?vue&type=template&id=2e37643a&scoped=true"
import script from "./order-sort-modal.vue?vue&type=script&lang=js"
export * from "./order-sort-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e37643a",
  null
  
)

export default component.exports